export default __webpack_public_path__ + "static/media/ColonialPenn dark.946d7823.svg";